import {
  enumInventoryLotSortOption,
  InventoryLotSortOption,
  LotStatus,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inventoryLotsQueryAtom } from '../_graphql/queryInventoryLots';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $selectedStatus = atomFromQueryString.string('status');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<InventoryLotSortOption[]>([
  enumInventoryLotSortOption.LotNumberAsc,
]);

export const $isCreateDialogOpen = atom(false);
export const $editingLotId = atom<string | null>(null);

export const $remoteInventoryLots = inventoryLotsQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const selectedFacility = get($selectedFacility);
  const selectedStatus = get($selectedStatus);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    lotNumber?: string;
    facilityId?: string;
    status?: LotStatus;
    limit: number;
    offset: number;
    sorting: InventoryLotSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (searchTerm) params.lotNumber = searchTerm;
  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityId = selectedFacility;
  }
  if (selectedStatus && selectedStatus !== 'all') {
    params.status = selectedStatus as LotStatus;
  }

  return {
    variables: params,
  };
});
